import {Component, Input, OnInit} from '@angular/core';
import {Producto} from "../../../_models/producto";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ListaItem} from "../../../_models/lista-item";
import {ConfirmationService, SelectItem} from "primeng/api";
import {NavService} from "../../../_services/_nav.service";
import {ListaService} from "../../../_services/lista.service";
import {ProductosReferenciasDesembolsos} from "../../../_models/productos-referencias-desembolsos";
import {
  ProductoReferenciaMetodoDesembolsoService
} from "../../../_services/producto-referencia-metodo-desembolso.service";
import {forkJoin} from 'rxjs';
import {FormaDesembolsoService} from "../../../_services/forma-desembolso.service";
import {FormaDesembolso} from "../../../_models/forma-desembolso";

@Component({
  selector: 'app-referencia-metodo-desembolso',
  templateUrl: './referencia-metodo-desembolso.component.html'
})
export class ReferenciaMetodoDesembolsoComponent implements OnInit {
  @Input() producto: Producto;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  listDesembolsosTodos: FormaDesembolso[];
  listDesembolsos: SelectItem[];
  productosReferenciasDesembolsos: ProductosReferenciasDesembolsos;
  listaReferenciasDesembolsos: ProductosReferenciasDesembolsos[];
  carInformacionInicial = true;

  constructor(
    private conServicio: ConfirmationService,
    private navServicio: NavService,
    private lisServicio: ListaService,
    private productoRefMetDesService: ProductoReferenciaMetodoDesembolsoService,
    private formaDesembolsoService: FormaDesembolsoService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {

    this.listDesembolsos = [];
    forkJoin(this.productoRefMetDesService.listadoPorId(this.producto.idProducto),
      this.formaDesembolsoService.listadoHabilitado(),
      ).subscribe( ( [ res, listas] ) => {
      this.listaReferenciasDesembolsos = res;
      this.listDesembolsosTodos = listas;
      this.listDesembolsosTodos.map(( s: FormaDesembolso ) => {
        this.listDesembolsos.push({label: s.nombre, value: s.idFormaDesembolso});
        this.cargarFormulario();
      });
    });

  }

  cargarFormulario(){
    const ids = [];
    if(this.listaReferenciasDesembolsos){
      this.listaReferenciasDesembolsos.forEach(e => {
        if(e.indicadorHabilitado){
          ids.push(e.idFormaDesembolso);
        }
      });
    }
    this.formulario = this.fb.group( {
      idProductoReferenciaDesembolso: [this.productosReferenciasDesembolsos ? this.productosReferenciasDesembolsos.idProductoReferenciaDesembolso: null],
      idFormaDesembolso: [ ids, [Validators.required]],
      idProducto: [this.productosReferenciasDesembolsos ? this.productosReferenciasDesembolsos.idProducto: null],
      indicadorHabilitado: [this.productosReferenciasDesembolsos ? this.productosReferenciasDesembolsos.indicadorHabilitado: false],
      auditoriaUsuario: [this.productosReferenciasDesembolsos ? this.productosReferenciasDesembolsos.auditoriaUsuario: null],
      auditoriaFecha: [this.productosReferenciasDesembolsos ? this.productosReferenciasDesembolsos.auditoriaFecha: null],

    });
    this.carInformacionInicial = false;
  }

  get f(){
    return this.formulario.controls;
  }

  onSubmit(){
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando= true;
      const forData = this.formulario.value;
      const tempReferenciasDesembolso: ProductosReferenciasDesembolsos[] = [];

      forData.idFormaDesembolso.forEach( formaDesembolso => {
        let temp = {} as ProductosReferenciasDesembolsos;
        temp.idProducto = this.producto.idProducto;
        temp.idFormaDesembolso = formaDesembolso;
        temp.indicadorHabilitado = true;
        temp.auditoriaFecha = this.producto.auditoriaFecha;
        temp.auditoriaUsuario = this.producto.auditoriaUsuario;
        const a = this.listaReferenciasDesembolsos.find( sp => sp.idFormaDesembolso === temp.idFormaDesembolso );
        if ( a ) {
          temp.idProductoReferenciaDesembolso = a.idProductoReferenciaDesembolso;
        }
        tempReferenciasDesembolso.push( temp );
      } );

      this.listaReferenciasDesembolsos.forEach( e => {
        if ( e.indicadorHabilitado && !forData.idFormaDesembolso.find( y => y === e.idFormaDesembolso ) ) {
          e.indicadorHabilitado = false;
          tempReferenciasDesembolso.push( e );
        }
      } );

      if ( tempReferenciasDesembolso.length > 0 ) {
        this.productoRefMetDesService.bulk(tempReferenciasDesembolso).subscribe(s => {
          this.listaReferenciasDesembolsos = [];
          this.listaReferenciasDesembolsos = s;
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        } ,error => {
          this.navServicio.setMesage( 3 );
        });
      }
    }
  }

  salir( mensaje: number ) {
    this.cargarFormulario();
    this.submitted = false;
    this.guardando = false;
    if ( mensaje !== null && mensaje !== undefined ) {
      this.navServicio.setMesage( mensaje );
    }

  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'referencias-metodos-desembolso',
        accept: () => {
          this.salir( null );
        },
        reject: () => {
        }
      } );
    } else {
      this.salir( null );
    }
  }

}
